export default __webpack_public_path__ + "static/media/rocket.48f7d8cf.ogg";